import { configureStore } from '@reduxjs/toolkit';

import counterReducer from '../features/counter/counterSlice';
import postsReducer from '../features/posts/postsSlice';
import usersReducer from '../features/users/usersSlice';
import homesReducer from '../features/homes/homesSlice';
import opportunitiesReducer from '../features/opportunities/opportunitiesSlice';

// import participantsReducer from '../features/participants/participantsSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    posts: postsReducer,
    users: usersReducer,
    homes: homesReducer,
    opportunities: opportunitiesReducer,

    // participants: participantsReducer,
  },
});
